<template>
  <div>
    <div class="modal__poi-template-wrapper">
        <div v-if="modalData && modalData.description" class="modal__poi-description" v-html="modalData.description"></div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent, onMounted, Ref, ref, watch,
} from 'vue';
import ModalTemplateService from '@/services/ModalTemplateService';
import store from '@/store/index';
import { IModalData } from '@/services/layers/IModalData';
import IPosition from '@/interfaces/IPosition';

const TemplateModalPoi: object = defineComponent({
  props: {
    templateData: {
      type: Object,
      required: true,
    },
  },
  name: 'TemplateModalPoi',
  setup(props) {
    const modalData: Ref<IModalData|null> = ref(null);

    onMounted(() => {
      const { metaData } = props.templateData;
      // console.log();
      modalData.value = metaData;
    });

    return {
      modalData,
    };
  },
});
export default TemplateModalPoi;
</script>

<style scoped lang="scss">
.modal__poi {
    &-description {
        text-align: center;
        font-weight: 700;
        letter-spacing: .5px;
    }

    &-fly-to {
      text-align: center;
      margin-top: 16px;

      &-btn {
        text-decoration: underline;
      }
    }
}
</style>
